import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import { FixedCenterCircularProgress } from 'src/components/progress/fixed-center-circular-progress';
import { DashboardContent } from 'src/layouts/dashboard';
import type { TableHeadCellProps } from 'src/components/table';
import { useTable, TableNoData, TableHeadCustom } from 'src/components/table';
import { Dispatch } from 'react';
import { TableLoading } from 'src/components/table/table-loading';
import { Card } from '@mui/material';
import { ROWS_PER_PAGE } from '../useGetPaginatedInvoices';
import { CustomServerPagination } from 'src/components/custom-server-pagination/CustomServerPagination';
import {
  dispatchPage,
  dispatchSorting,
  getSorting,
  IAction,
  IPaginationState,
} from 'src/utils/server-side-pagination';

type Props = {
  isLoading: boolean;
  isFetching: boolean;
  tableHeadColumns: TableHeadCellProps[];
  data: Array<any>;
  customGridRow: (rowProps: any) => JSX.Element;
  defaultOrderBy?: string;
  totalItems?: number;
  totalPages?: number;
  paginationPage: number;
  dispatch: Dispatch<IAction>;
  sorting: IPaginationState['sorting'];
};

export function ReusableTable({
  isLoading,
  isFetching,
  tableHeadColumns,
  data,
  customGridRow,
  dispatch,
  defaultOrderBy = '',
  totalItems,
  totalPages,
  paginationPage,
  sorting,
}: Props) {
  const table = useTable({
    defaultOrderBy,
    defaultDense: true,
    defaultCurrentPage: paginationPage,
    defaultRowsPerPage: ROWS_PER_PAGE,
    defaultOrder: 'asc',
  });

  const notFound = !data.length;

  return (
    <DashboardContent>
      {isLoading && <FixedCenterCircularProgress />}

      {!isLoading && (
        <Card>
          <Box sx={{ position: 'relative', overflowX: 'auto' }}>
            <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 1000 }}>
              <TableHeadCustom
                order={getSorting(sorting).order}
                orderBy={getSorting(sorting).orderBy}
                headCells={tableHeadColumns}
                rowCount={ROWS_PER_PAGE}
                numSelected={table.selected.length}
                onSort={dispatchSorting(dispatch)}
              />

              <TableBody>
                {!isFetching && (
                  <>
                    {data.map((row, index) =>
                      customGridRow({
                        rowIndex: index,
                        row,
                        table,
                      })
                    )}

                    {/* <TableEmptyRows
                      height={table.dense ? 56 : 56 + 20}
                      emptyRows={emptyRows(table.page, table.rowsPerPage, data.length)}
                    /> */}

                    <TableNoData notFound={notFound} />
                  </>
                )}

                {isFetching && <TableLoading />}
              </TableBody>
            </Table>
          </Box>

          {!isFetching && (
            <CustomServerPagination
              totalPages={totalPages ?? 0}
              currentPage={paginationPage}
              changePage={dispatchPage(dispatch)}
            />
          )}
        </Card>
      )}
    </DashboardContent>
  );
}
